import React, { useEffect, useState } from "react";
import { IconX, IconDownload, IconEye } from "@tabler/icons-react";
import { toast } from "sonner";
import Loader from "./Loader";

//const IP = "http://localhost:5020";
const IP = "https://reportes.aux-rolplay.com";

const ModalSimV2 = ({ isOpen, onClose }) => {
  const [data, setData] = useState([]);
  const [tooltipUrl, setTooltipUrl] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [isExiting, setIsExiting] = useState(false);

  useEffect(() => {
    if (isOpen) {
      // Reset states when modal opens
      setIsLoading(true);
      setIsExiting(false);

      fetch(`${IP}/somos/historicosim2`)
        .then((response) => response.json())
        .then((result) => {
          setData(result.dataSimv2 || []);
          setIsExiting(true);
          setTimeout(() => setIsLoading(false), 500);
        })
        .catch((error) => {
          console.error("Error:", error);
          toast.error("Error al cargar los datos históricos");
          setIsExiting(true);
          setTimeout(() => setIsLoading(false), 500);
        });
    }
  }, [isOpen]);

  const handleClose = () => {
    setIsLoading(true); // Reset loading state when closing
    onClose();
  };

  const downloadCSV = () => {
    const headers = [
      "Gerente",
      "Nombre Usuario",
      "Usuario",
      "Sucursal",
      "Puesto",
      "Simulador",
      "Calificación",
      "Fecha",
      "URL de Visualización",
    ];

    const csvData = data.map((row) => [
      row.sim_gerente,
      row.sim_user,
      row.sim_user_access,
      row.user_branch,
      row.user_profile,
      row.sim_title,
      row.sim_score,
      row.sim_datetime,
      row.sim_view_url,
    ]);

    const csvContent = [
      headers.join(","),
      ...csvData.map((row) => row.join(",")),
    ].join("\n");
    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = "historico_simulaciones.csv";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    toast.success("Archivo descargado correctamente");
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black/70 flex justify-center items-center z-50 p-4 backdrop-blur-sm">
      {isLoading ? (
        <Loader isExiting={isExiting} />
      ) : (
        <div className="bg-white rounded-2xl w-11/12 max-w-7xl h-[85vh] relative flex flex-col shadow-2xl">
          <button
            onClick={handleClose}
            className="absolute -top-3 -right-3 w-8 h-8 bg-red-600 text-white rounded-full flex items-center justify-center hover:bg-red-700 transition-opacity duration-200 z-50"
          >
            <IconX size={20} />
          </button>

          <div className="p-6 bg-gradient-to-r from-[#991b1b] to-[#dc2626] rounded-t-2xl">
            <h2 className="text-white text-lg font-medium">
              Histórico de Simulador 2
            </h2>
          </div>

          <div className="flex-1 overflow-auto p-6">
            <div className="bg-white rounded-xl shadow-lg overflow-hidden">
              <div className="overflow-x-auto">
                <table className="w-full">
                  <thead className="bg-gradient-to-r from-[#991b1b] to-[#dc2626] text-white">
                    <tr>
                      <th className="px-4 py-3 text-[13px] font-medium text-left">
                        Gerente
                      </th>
                      <th className="px-4 py-3 text-[13px] font-medium text-left">
                        Nombre Usuario
                      </th>
                      <th className="px-4 py-3 text-[13px] font-medium text-left">
                        Usuario
                      </th>
                      <th className="px-4 py-3 text-[13px] font-medium text-left">
                        Sucursal
                      </th>
                      <th className="px-4 py-3 text-[13px] font-medium text-left">
                        Puesto
                      </th>
                      <th className="px-4 py-3 text-[13px] font-medium text-left">
                        Simulador
                      </th>
                      <th className="px-4 py-3 text-[13px] font-medium text-left">
                        Calificación
                      </th>
                      <th className="px-4 py-3 text-[13px] font-medium text-left">
                        Fecha
                      </th>
                      <th className="px-4 py-3 text-[13px] font-medium text-center">
                        Acciones
                      </th>
                    </tr>
                  </thead>
                  <tbody className="divide-y divide-gray-100">
                    {data.map((row, index) => (
                      <tr key={index} className="hover:bg-gray-50">
                        <td className="px-4 py-2.5 text-[13px] text-gray-600">
                          {row.sim_gerente}
                        </td>
                        <td className="px-4 py-2.5 text-[13px] text-gray-600">
                          {row.sim_user}
                        </td>
                        <td className="px-4 py-2.5 text-[13px] text-gray-600">
                          {row.sim_user_access}
                        </td>
                        <td className="px-4 py-2.5 text-[13px] text-gray-600">
                          {row.user_branch}
                        </td>
                        <td className="px-4 py-2.5 text-[13px] text-gray-600">
                          {row.user_profile}
                        </td>
                        <td className="px-4 py-2.5 text-[13px] text-gray-600">
                          <span className="inline-flex px-2.5 py-1 rounded-full bg-gradient-to-r from-red-100 to-red-200 text-red-800 text-center border border-red-200 font-medium">
                            {row.sim_title}
                          </span>
                        </td>
                        <td className="px-4 py-2.5 text-[13px] text-gray-600">
                          {row.sim_score}
                        </td>
                        <td className="px-4 py-2.5 text-[13px] text-gray-600">
                          {row.sim_datetime}
                        </td>
                        <td className="px-4 py-2.5 text-[13px] text-center">
                          <button
                            onClick={() =>
                              setTooltipUrl(
                                tooltipUrl === row.sim_view_url
                                  ? null
                                  : row.sim_view_url,
                              )
                            }
                            className="inline-flex items-center gap-2 px-4 py-2 bg-[#4B5563] text-white text-[13px] rounded-full hover:bg-red-600 transition-colors duration-300"
                          >
                            <IconEye size={16} />
                            Ver
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>

          <div className="p-6 border-t border-gray-200 flex justify-center">
            <button
              onClick={downloadCSV}
              className="px-6 py-3 bg-gradient-to-r from-[#dc2626] to-[#991b1b] text-white rounded-full hover:from-[#991b1b] hover:to-[#dc2626] transition-all duration-300 text-sm shadow-md hover:shadow-xl flex items-center gap-2"
            >
              <IconDownload size={18} />
              Descargar CSV
            </button>
          </div>
        </div>
      )}

      {/* Modal de visualización */}
      {tooltipUrl && (
        <div className="fixed inset-0 bg-black/70 flex items-center justify-center z-[60]">
          <div className="bg-white rounded-xl w-[90%] h-[80vh] max-w-6xl relative">
            <button
              onClick={() => setTooltipUrl(null)}
              className="absolute -top-3 -right-3 w-8 h-8 bg-red-600 text-white rounded-full flex items-center justify-center hover:bg-red-700 transition-colors z-50 shadow-lg"
            >
              <IconX size={20} />
            </button>
            <div className="w-full h-full rounded-xl overflow-hidden">
              <iframe
                src={tooltipUrl}
                title="Preview"
                className="w-full h-full border-none"
              />
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ModalSimV2;
